import React, { Component } from 'react';
import '../../css/style.css';
import '../Home.css';
import { Card, Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { translate } from "react-i18next";
import { EVENT_IMG_URL } from '../../backend/Backend';
import { Link } from 'react-router-dom';
import { getDateDisplayValue } from '../../backend/UIUtils';




class PublicEvents extends Component {

  constructor(props) {
    super(props);

    this.state = {
      events: this.props.events
    };
  }

  //<p className="card-text">{e.description}</p>
  render() {
    const { t } = this.props;
    var options = { weekday: 'short', day: 'numeric', month: 'short', year: '2-digit', hour: 'numeric', minute: 'numeric' };
    return (
      <div >
        <Row className="justify-content-md-center" >
          {this.props.events.map((e, i) =>
            <Col lg={4} md={4} xs={12} className=" mb-2  " key={i}>
              <Card style={{height:"100%"}}>
                <Card.Img variant="top" src={e.imageName ? EVENT_IMG_URL + e.imageName : "/img/produkt-premium-3.jpg"} height={"200px"} />
                <Card.Body>
                  <Card.Title  ><h4 className="card-title text-dark ">
                  <Link to={`/showevent/${e.id}`}  className=" text-dark ">{e.title}</Link></h4></Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">
                  <Row>
                      <Col><i className="text-primary fa fa-user s16  mr-1" ></i>{e.creationUserName}</Col>
                    </Row>
                    <Row>
                      <Col>
                    <i className="text-primary fa fa-clock s16  mr-1" ></i>{getDateDisplayValue(e.startDate, options)}
                    </Col>
                    </Row>
                    </Card.Subtitle>
                  <Card.Text>
                    {e.description}
                      </Card.Text>
                  
                  <Row>
                  {(this.props.edit && e.bookingType === 'INTERN' )?
                      <Col className="float-left">
                        <OverlayTrigger
                          key="top"
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-top`}>
                              {t("bookings")}
                            </Tooltip>
                          }>
                          <Link to={`/booked/${e.id}/${e.title}`} className={' float-left '}>
                          <i class="fas fa-shopping-cart"></i></Link>
                        </OverlayTrigger>
                      </Col>
                      :
                      ""
                    }
                    
                    {this.props.edit ?
                      <Col className="float-right">
                        <OverlayTrigger
                          key="top"
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-top`}>
                              {t("bearbeiten")}
                            </Tooltip>
                          }>
                          <Link to={`/pubEventEdit/${e.id}`} className={' float-right '}>
                          <span className="fa fa-edit"></span></Link>
                        </OverlayTrigger>
                      </Col>
                      :
                      ""
                    }

                  </Row>

                </Card.Body>
              </Card>
            </Col>
          )
          }
        </Row>
      </div>
    );
  }
}

export default translate("translations")(PublicEvents);